import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('DRAWER', {
  TOGGLE: null
});
